module.exports = __webpack_public_path__ + "img/Speaker=Aashni Shah.978a704f.png";